import { NavSidebarSection, NavSidebarViewSwitcher } from '@insurancemenu/imenu-components-lib';
import { Notification, Person } from '@insurancemenu/imenu-components-lib/dist/icons';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { redirectToRoute } from 'routes/redirectToRoute';
import { ROUTES_CONFIG_V2, RouteV2Id, UserSettingsRouteV2Id } from 'routes/routesConfigV2';

interface Props {
  pageId: UserSettingsRouteV2Id;
}
const USER_SETTINGS_ROUTES = [UserSettingsRouteV2Id.ACCOUNT_SETTINGS, UserSettingsRouteV2Id.NOTIFICATION_SETTINGS];

const ICON_MAP: Record<UserSettingsRouteV2Id, React.FC> = {
  [UserSettingsRouteV2Id.ACCOUNT_SETTINGS]: Person,
  [UserSettingsRouteV2Id.NOTIFICATION_SETTINGS]: Notification,
};

const NavigationSidebar: React.FC<Props> = observer(({ pageId }) => {
  const onRedirectClick = (routeId: UserSettingsRouteV2Id): void => {
    redirectToRoute(routeId as RouteV2Id, {});
  };

  const items = USER_SETTINGS_ROUTES.map((routeId) => ({
    label: ROUTES_CONFIG_V2[routeId].title,
    icon: ICON_MAP[routeId],
    onClick: (): void => onRedirectClick(routeId),
  }));

  return (
    <NavSidebarSection label="Settings">
      <NavSidebarViewSwitcher items={items} currentIndex={USER_SETTINGS_ROUTES.indexOf(pageId)} />
    </NavSidebarSection>
  );
});

export default NavigationSidebar;
